module.exports = __webpack_public_path__ + "static/media/select2.463bf52f.jpg";